import { render, staticRenderFns } from "./agendaPc.vue?vue&type=template&id=52ee8d4e&scoped=true"
import script from "./agendaPc.vue?vue&type=script&lang=js"
export * from "./agendaPc.vue?vue&type=script&lang=js"
import style0 from "./agendaPc.vue?vue&type=style&index=0&id=52ee8d4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee8d4e",
  null
  
)

export default component.exports